import { render, staticRenderFns } from "./ResultsByProducts.vue?vue&type=template&id=634fe52f"
import script from "./ResultsByProducts.vue?vue&type=script&lang=js"
export * from "./ResultsByProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports